<template>
    <form id="Form__logout" action="/logout" method="post">
        <input name="_token" type="hidden" :value="csrfToken">
        <a href="#" @click.prevent="logout()">Logout</a>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                csrfToken: Laravel.csrfToken
            }
        },

        methods: {
            /**
             * Submit the form
             */
            logout: _.once(() => {
                document.getElementById('Form__logout').submit()
            }),
        }
    }
</script>
